module.exports = __webpack_public_path__ + "static/media/jobreel.9f2ed637.png";